
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 4.406l-.406.188-10 4.5-.594.25V22.03l.5.282 10 5.562.5.281.5-.281 10-5.563.5-.28V9.343l-.594-.25-10-4.5zm0 2.188l7.688 3.437L16 13.875l-7.688-3.844zm-9 5.031l8 4v9.656l-8-4.437zm18 0v9.219l-8 4.437v-9.656z"}})])
          )
        }
      }
    